export default "__VITE_ASSET__Bj9NmkdU__"